import { render, staticRenderFns } from "./ProxyInfoFormDialog.vue?vue&type=template&id=5fb552e2&scoped=true&"
import script from "./ProxyInfoFormDialog.vue?vue&type=script&lang=ts&"
export * from "./ProxyInfoFormDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ProxyInfoFormDialog.vue?vue&type=style&index=0&id=5fb552e2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb552e2",
  null
  
)

export default component.exports